(() => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
  }

  const productForm = document.querySelector('[data-product-form]');
  const variantData = document.querySelector('[data-product-json]');
  if (productForm && variantData) {
    const variants = JSON.parse(variantData.textContent);
    const optionSelects = [...productForm.querySelectorAll('[data-option-select]')];
    const variantSelect = productForm.querySelector('[data-variant-select]');
    const submit = productForm.querySelector('[type="submit"]');
    const updateVariant = () => {
      const values = optionSelects.map((select) => select.value);
      const variant = variants.find((candidate) => candidate.options.every((value, index) => value === values[index]));
      if (!variant) return;
      variantSelect.value = String(variant.id);
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? 'Add to cart' : 'Sold out';
    };
    optionSelects.forEach((select) => select.addEventListener('change', updateVariant));
  }

  document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
    const slides = [...slider.querySelectorAll('[data-hero-slide]')];
    const dots = [...slider.querySelectorAll('[data-hero-dot]')];
    if (slides.length < 2) return;

    let activeIndex = 0;
    let timer;
    const delay = Math.max(3000, Number(slider.dataset.autoplayDelay) || 6000);
    const autoplay = slider.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const show = (nextIndex, userInitiated = false) => {
      activeIndex = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const active = index === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, index) => {
        const active = index === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
      if (userInitiated) restart();
    };

    const restart = () => {
      window.clearInterval(timer);
      if (autoplay) timer = window.setInterval(() => show(activeIndex + 1), delay);
    };

    slider.querySelector('[data-hero-previous]')?.addEventListener('click', () => show(activeIndex - 1, true));
    slider.querySelector('[data-hero-next]')?.addEventListener('click', () => show(activeIndex + 1, true));
    dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.slideIndex), true)));
    slider.addEventListener('mouseenter', () => window.clearInterval(timer));
    slider.addEventListener('mouseleave', restart);
    slider.addEventListener('focusin', () => window.clearInterval(timer));
    slider.addEventListener('focusout', restart);
    restart();
  });
})();
